import { useState, useEffect } from "preact/hooks";
import { getQueryString } from "../helpers/getQueryString";

export const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const { darkMode } = getQueryString(window.location.href);
    // const prefersDarkMode = window.matchMedia(
    //   "(prefers-color-scheme: dark)",
    // ).matches;

    if (darkMode) {
      setIsDarkMode(true);
    }
  }, []);

  return { isDarkMode };
};
